/* ============================================================
   SARAYA — Header
   Mega menus · mobile menu · native Shopify cart drawer
   All cart reads/writes use /cart.js and /cart/change.js.
   Checkout is Shopify's own — nothing custom.
   ============================================================ */
(function () {
  'use strict';
 
  var VERSION = '11';
  window.SarayaHeader = window.SarayaHeader || {};
  window.SarayaHeader.version = VERSION;
 
  var root = document.querySelector('.saraya-hdr');
  if (!root) { console.log('[saraya-header v' + VERSION + '] header markup not found'); return; }
  console.log('[saraya-header v' + VERSION + '] ready');
  window.addEventListener('error', function (e) {
    if (e && e.filename && e.filename.indexOf('saraya-header') > -1) {
      console.log('[saraya-header v' + VERSION + '] OUR ERROR → ' + e.message + ' (line ' + e.lineno + ')');
    }
  });
 
  var header  = root.querySelector('[data-saraya-header]');
  var nav     = root.querySelector('[data-hdr-nav]');
  var mega    = root.querySelector('[data-hdr-mega]');
  var drawer  = root.querySelector('[data-hdr-drawer]');
  var scrim   = root.querySelector('[data-hdr-scrim]');
  var burger  = root.querySelector('[data-hdr-burger]');
  var closeEl = root.querySelector('[data-hdr-close]');
 
  var cartUrl     = (header && header.dataset.cartUrl) || '/cart';
  var cartAction  = (header && header.dataset.cartAction) || 'drawer';
  var openOnAdd   = header && header.dataset.openOnAdd === 'true';
  var moneyFormat = (header && header.dataset.moneyFormat) || '${{amount}}';
 
  /* =========================================================
     1. Mega menu
  ========================================================= */
  var closeTimer = null;
  var openKey = null;
 
  function panels() { return mega ? mega.querySelectorAll('[data-hdr-panel]') : []; }
  function items()  { return nav  ? nav.querySelectorAll('[data-hdr-item]')   : []; }
 
  function sizeMega() {
    if (!mega) return;
    var on = mega.querySelector('.hdr__panel.is-on');
    if (on) mega.style.setProperty('--mega-max', on.scrollHeight + 40 + 'px');
  }
 
  function openMega(key) {
    if (!mega || !key) return;
    window.clearTimeout(closeTimer);
    openKey = key;
    Array.prototype.forEach.call(panels(), function (p) {
      p.classList.toggle('is-on', p.dataset.hdrPanel === key);
    });
    Array.prototype.forEach.call(items(), function (it) {
      var match = it.dataset.hdrItem === key;
      it.classList.toggle('is-active', match);
      var a = it.querySelector('.hdr__link');
      if (a && a.hasAttribute('aria-expanded')) a.setAttribute('aria-expanded', match ? 'true' : 'false');
    });
    sizeMega();
    mega.classList.add('is-open');
    header.classList.add('is-open');
  }
 
  function closeMega(immediate) {
    window.clearTimeout(closeTimer);
    var run = function () {
      openKey = null;
      if (mega) mega.classList.remove('is-open');
      if (header) header.classList.remove('is-open');
      Array.prototype.forEach.call(items(), function (it) {
        it.classList.remove('is-active');
        var a = it.querySelector('.hdr__link');
        if (a && a.hasAttribute('aria-expanded')) a.setAttribute('aria-expanded', 'false');
      });
    };
    if (immediate) run(); else closeTimer = window.setTimeout(run, 140);
  }
 
  // every nav item gets a handler: ones with a panel open it, plain links close it
  if (nav) {
    Array.prototype.forEach.call(nav.querySelectorAll('.hdr__item'), function (it) {
      var key = it.dataset.hdrItem || null;
      it.addEventListener('mouseenter', function () { key ? openMega(key) : closeMega(true); });
      it.addEventListener('focusin',    function () { key ? openMega(key) : closeMega(true); });
    });
    nav.addEventListener('mouseleave', function () { closeMega(); });
  }
  // moving onto the logo or the utilities also closes it
  Array.prototype.forEach.call(root.querySelectorAll('.hdr__logo, .hdr__utils'), function (el) {
    el.addEventListener('mouseenter', function () { closeMega(true); });
  });
  if (mega) {
    mega.addEventListener('mouseenter', function () { window.clearTimeout(closeTimer); });
    mega.addEventListener('mouseleave', function () { closeMega(); });
  }
  document.addEventListener('focusin', function (e) {
    if (openKey && header && !header.contains(e.target)) closeMega(true);
  });
  window.addEventListener('resize', function () { if (openKey) sizeMega(); }, { passive: true });
 
  /* =========================================================
     2. Announcement height + scroll states
  ========================================================= */
  var fixedEl  = root.querySelector('[data-hdr-fixed]');
  var announce = root.querySelector('[data-hdr-announce]');
  var annH = 0;
 
  function measure() {
    annH = announce ? announce.offsetHeight : 0;
    root.style.setProperty('--ann-h', annH + 'px');
  }
  measure();
  if ('ResizeObserver' in window && announce) new ResizeObserver(measure).observe(announce);
  else window.addEventListener('resize', measure, { passive: true });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
 
  var isTransparent = header && header.classList.contains('hdr--transparent');
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      var y = window.scrollY || window.pageYOffset || 0;
      if (fixedEl) fixedEl.classList.toggle('is-scrolled', y > Math.max(4, annH * 0.5));
      if (isTransparent) header.classList.toggle('is-solid', y > Math.max(80, window.innerHeight * 0.55));
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  onScroll();
 
  /* =========================================================
     3. Mobile menu
  ========================================================= */
  function openDrawer() {
    if (!drawer) return;
    scrim.hidden = false;
    window.requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      scrim.classList.add('is-open');
    });
    drawer.setAttribute('aria-hidden', 'false');
    if (burger) burger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('hdr-locked');
    var first = drawer.querySelector('button, a');
    if (first) first.focus({ preventScroll: true });
  }
 
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    scrim.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (burger) { burger.setAttribute('aria-expanded', 'false'); burger.focus({ preventScroll: true }); }
    document.body.classList.remove('hdr-locked');
    window.setTimeout(function () { if (!drawer.classList.contains('is-open')) scrim.hidden = true; }, 500);
  }
 
  if (burger)  burger.addEventListener('click', openDrawer);
  if (closeEl) closeEl.addEventListener('click', closeDrawer);
  if (scrim)   scrim.addEventListener('click', closeDrawer);
 
  // accordion mode only
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var btn = e.target.closest('.hdr__acc-btn');
      if (!btn) return;
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      Array.prototype.forEach.call(drawer.querySelectorAll('.hdr__acc-btn'), function (b) {
        if (b === btn) return;
        b.setAttribute('aria-expanded', 'false');
        var p = document.getElementById(b.getAttribute('aria-controls'));
        if (p) p.style.maxHeight = '0px';
      });
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      panel.style.maxHeight = isOpen ? '0px' : panel.scrollHeight + 'px';
    });
  }
 
  /* =========================================================
     4. Money formatting
  ========================================================= */
  function withCommas(n) { return n.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'); }
  function withPeriods(n) { return n.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.'); }
 
  function money(cents) {
    var value = '';
    var fmt = String(moneyFormat).replace(/<[^>]*>/g, '');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = fmt.match(placeholder);
    var name = match ? match[1] : 'amount';
    var num = (Number(cents) || 0) / 100;
 
    switch (name) {
      case 'amount':
        value = withCommas(num.toFixed(2));
        break;
      case 'amount_no_decimals':
        value = withCommas(Math.round(num).toString());
        break;
      case 'amount_with_comma_separator':
        value = withPeriods(num.toFixed(2).replace('.', ','));
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withPeriods(Math.round(num).toString());
        break;
      case 'amount_with_apostrophe_separator':
        value = num.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1'");
        break;
      default:
        value = withCommas(num.toFixed(2));
    }
    return fmt.replace(placeholder, value);
  }
 
  /* =========================================================
     5. Cart drawer — native cart
  ========================================================= */
  var cartEl     = root.querySelector('[data-cart-drawer]');
  var cartScrim  = root.querySelector('[data-cart-scrim]');
  var cartItems  = root.querySelector('[data-cart-items]');
  var cartFoot   = root.querySelector('[data-cart-foot]');
  var cartEmpty  = root.querySelector('[data-cart-empty]');
  var cartTotal  = root.querySelector('[data-cart-total]');
  var cartClose  = root.querySelector('[data-cart-close]');
 
  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
 
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
 
  var shipEl   = root.querySelector('[data-ship]');
  var shipTxt  = root.querySelector('[data-ship-txt]');
  var shipFill = root.querySelector('[data-ship-fill]');
 
  function renderShipping(cart) {
    if (!shipEl) return;
    var threshold = parseInt(shipEl.dataset.shipThreshold, 10) || 0;
    if (!threshold || !cart || cart.item_count === 0) { shipEl.hidden = true; return; }
 
    shipEl.hidden = false;
    var total = cart.total_price || 0;
    var left = threshold - total;
    var pct = Math.max(0, Math.min(100, (total / threshold) * 100));
 
    if (left > 0) {
      shipTxt.innerHTML = String(shipEl.dataset.shipProgress || 'You are [amount] away from free shipping')
        .replace(/\[amount\]|\{\{\s*amount\s*\}\}/gi, '<b>' + money(left) + '</b>');
    } else {
      shipTxt.textContent = shipEl.dataset.shipDone || 'You have earned free shipping';
    }
    shipFill.style.width = pct + '%';
  }
 
  function renderCart(cart) {
    if (!cartItems) return;
    var empty = !cart || cart.item_count === 0;
 
    if (cartEmpty) cartEmpty.hidden = !empty;
    if (cartFoot)  cartFoot.hidden  = empty;
    renderShipping(cart);
    if (empty) { cartItems.innerHTML = ''; return; }
 
    cartItems.innerHTML = cart.items.map(function (it) {
      var opts = (it.options_with_values || [])
        .filter(function (o) { return o.value && o.value !== 'Default Title'; })
        .map(function (o) { return esc(o.value); }).join(' · ');
      var img = it.image ? '<img src="' + sized(it.image, 200) + '" alt="' + esc(it.product_title) + '" loading="lazy" decoding="async" width="76" height="91">' : '';
      return '' +
        '<div class="hdr__ci" data-line="' + it.key + '">' +
          '<a class="hdr__ci-im" href="' + it.url + '">' + img + '</a>' +
          '<div>' +
            '<a class="hdr__ci-name" href="' + it.url + '">' + esc(it.product_title) + '</a>' +
            (opts ? '<div class="hdr__ci-var">' + opts + '</div>' : '') +
            '<div class="hdr__ci-row">' +
              '<span class="hdr__qty">' +
                '<button type="button" data-qty="-1" aria-label="Decrease quantity">&minus;</button>' +
                '<span>' + it.quantity + '</span>' +
                '<button type="button" data-qty="1" aria-label="Increase quantity">+</button>' +
              '</span>' +
              '<span class="hdr__ci-price">' + money(it.final_line_price) + '</span>' +
            '</div>' +
            '<button type="button" class="hdr__ci-rm" data-remove>Remove</button>' +
          '</div>' +
        '</div>';
    }).join('');
 
    if (cartTotal) cartTotal.textContent = money(cart.total_price);
 
    // let cart-upsell apps re-inject after we rebuild the line items
    notifyApps('cart:rendered', { cart: cart });
    notifyApps('cart:refresh', { cart: cart });
  }
 
  function openCart() {
    if (!cartEl) return;
    cartScrim.hidden = false;
    window.requestAnimationFrame(function () {
      cartEl.classList.add('is-open');
      cartScrim.classList.add('is-open');
    });
    cartEl.setAttribute('aria-hidden', 'false');
    document.body.classList.add('hdr-locked');
    if (cartClose) cartClose.focus({ preventScroll: true });
    refreshCart(true);
    unlockCheckout();
    notifyApps('cart:open');
  }
 
  function closeCart() {
    if (!cartEl) return;
    cartEl.classList.remove('is-open');
    cartScrim.classList.remove('is-open');
    cartEl.setAttribute('aria-hidden', 'true');
    if (!drawer || !drawer.classList.contains('is-open')) document.body.classList.remove('hdr-locked');
    window.setTimeout(function () { if (!cartEl.classList.contains('is-open')) cartScrim.hidden = true; }, 500);
  }
 
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartScrim) cartScrim.addEventListener('click', closeCart);
 
  /* ---- checkout -------------------------------------------------------
     The button wears the theme's product-form classes so it matches the
     site. Those same classes usually carry the theme's add-to-cart JS,
     which calls preventDefault() and swallows the click. We intercept in
     the CAPTURE phase — before any theme handler can run — and post to
     Shopify's cart the same way the native button does.
  --------------------------------------------------------------------- */
  function checkoutUrl() {
    return cartUrl.replace(/\/cart\/?$/, '/checkout') || '/checkout';
  }
 
  // A disabled button fires no click at all, so nothing can intercept it.
  // Themes disable .product-form__submit when they find no variant — undo that.
  function unlockCheckout() {
    var list = document.querySelectorAll('[data-cart-checkout]');
    if (!list.length) return 0;
    Array.prototype.forEach.call(list, function (b) {
      if (b.hasAttribute('disabled')) b.removeAttribute('disabled');
      if (b.getAttribute('aria-disabled') === 'true') b.setAttribute('aria-disabled', 'false');
      b.style.pointerEvents = 'auto';
    });
    return list.length;
  }
 
  try {
    if ('MutationObserver' in window && cartEl) {
      new MutationObserver(unlockCheckout).observe(cartEl, {
        subtree: true, childList: true, attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'style', 'class']
      });
    }
  } catch (err) {}
 
  window.SarayaHeader.checkCheckout = function () {
    var b = document.querySelector('[data-cart-checkout]');
    if (!b) return { found: false, note: 'no [data-cart-checkout] in the DOM — header.liquid is not the current version' };
    var cs = window.getComputedStyle(b);
    return {
      version: VERSION, found: true, tag: b.tagName,
      disabled: b.hasAttribute('disabled'),
      ariaDisabled: b.getAttribute('aria-disabled'),
      pointerEvents: cs.pointerEvents, visibility: cs.visibility, display: cs.display,
      inForm: !!b.form, formAction: b.form && b.form.getAttribute('action'),
      classes: b.className
    };
  };
 
  function goToCheckout(btn) {
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.classList.add('loading'); }
 
    var f = document.createElement('form');
    f.method = 'post';
    f.action = cartUrl;
    f.style.display = 'none';
    var i = document.createElement('input');
    i.type = 'hidden';
    i.name = 'checkout';
    i.value = 'Checkout';
    f.appendChild(i);
    document.body.appendChild(f);
 
    try { f.submit(); }
    catch (err) { window.location.href = checkoutUrl(); }
 
    // if anything blocked the POST, fall back to the checkout URL
    window.setTimeout(function () {
      if (btn) { btn.removeAttribute('aria-busy'); btn.classList.remove('loading'); }
      window.location.href = checkoutUrl();
    }, 2500);
  }
 
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-cart-checkout]');
    if (!btn) return;
 
    // Shopify blocks navigation to checkout inside the theme editor preview.
    if (window.Shopify && window.Shopify.designMode) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      console.log('[saraya-header v' + VERSION + '] Checkout is disabled inside the theme editor. ' +
                  'Open your storefront in a normal tab to test it.');
      btn.setAttribute('title', 'Checkout only works on the live storefront, not in the theme editor');
      return;
    }
    // If it's a real link, stop the theme hijacking it but let the browser navigate.
    if (btn.tagName === 'A' && btn.getAttribute('href')) {
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    try {
      goToCheckout(btn);
    } catch (err) {
      window.location.href = checkoutUrl();
    }
  }, true);
 
  // quantity + remove — native /cart/change.js
  if (cartItems) {
    cartItems.addEventListener('click', function (e) {
      var row = e.target.closest('[data-line]');
      if (!row) return;
      var key = row.dataset.line;
      var qtyBtn = e.target.closest('[data-qty]');
      var rmBtn  = e.target.closest('[data-remove]');
      if (!qtyBtn && !rmBtn) return;
 
      var current = parseInt(row.querySelector('.hdr__qty span').textContent, 10) || 0;
      var next = rmBtn ? 0 : current + parseInt(qtyBtn.dataset.qty, 10);
      if (next < 0) next = 0;
 
      row.style.opacity = '.45';
      fetch(cartUrl + '/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: next })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          renderCart(cart);
          paint(cart.item_count);
          notifyApps('cart:updated', { cart: cart });
        })
        .catch(function () { row.style.opacity = ''; });
    });
  }
 
  /* =========================================================
     6. Cart count sync
  ========================================================= */
  // events third-party upsell / cross-sell apps listen for
  function notifyApps(name, detail) {
    var payload = detail || {};
    payload.__saraya = true;               // so our own listener ignores it
    try {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: payload }));
      if (window.jQuery) window.jQuery(document).trigger(name, [payload]);
    } catch (err) {}
  }
 
  function paint(count) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cart-count]'), function (n) {
      if (parseInt(n.textContent, 10) === count) return;
      n.textContent = count;
      n.classList.remove('is-bump');
      void n.offsetWidth;
      n.classList.add('is-bump');
    });
    var link = root.querySelector('[data-hdr-cart]');
    if (link) link.setAttribute('aria-label', 'Cart, ' + count + ' items');
  }
 
  var refreshing = false;
  function refreshCart(force) {
    if (refreshing && !force) return;
    refreshing = true;
    return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c) return;
        paint(c.item_count);
        if (cartEl) renderCart(c);
        notifyApps('cart:updated', { cart: c });
      })
      .catch(function () {})
      .finally(function () { refreshing = false; });
  }
 
  var CART_ADD    = /\/cart\/add(\.js|\.json)?(\?|$)/i;
  var CART_CHANGE = /\/cart\/(change|update|clear)(\.js|\.json)?(\?|$)/i;
 
  function afterCartMutation(url) {
    refreshCart(true);
    if (openOnAdd && cartEl && CART_ADD.test(url) && !cartEl.classList.contains('is-open')) {
      window.setTimeout(openCart, 120);
    }
  }
 
  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function () {
      var args = arguments, url = '';
      try { url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || ''; } catch (err) {}
      var out = nativeFetch.apply(this, args);
      if (url && (CART_ADD.test(url) || CART_CHANGE.test(url))) {
        // ignore our own change.js calls — they render inline already
        if (!/\/cart\/change/i.test(url)) {
          out.then(function (res) { if (res && res.ok) afterCartMutation(url); }).catch(function () {});
        }
      }
      return out;
    };
  }
 
  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__saraya_url = typeof url === 'string' ? url : '';
    return nativeOpen.apply(this, arguments);
  };
  var nativeSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var u = this.__saraya_url || '';
    if (CART_ADD.test(u) || CART_CHANGE.test(u)) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) afterCartMutation(u);
      });
    }
    return nativeSend.apply(this, arguments);
  };
 
  ['cart:updated', 'cart:refresh', 'cart:build', 'ajaxCart.afterCartLoad'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      if (e && e.detail && e.detail.__saraya) return;   // never react to our own event
      refreshCart(true);
    });
  });
  document.addEventListener('shopify:section:load', function () { refreshCart(true); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(true); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refreshCart(true); });
 
  /* =========================================================
     7. Cart click behaviour
  ========================================================= */
  function themeDrawer() {
    var sels = ['cart-drawer', '#CartDrawer', '#cart-drawer', '.cart-drawer', '[data-cart-drawer]:not([data-cart-drawer=""])', '.drawer--cart', '#CartDrawer-Overlay'];
    for (var i = 0; i < sels.length; i++) {
      var el = document.querySelector(sels[i]);
      if (el && el !== cartEl) return el;
    }
    return null;
  }
 
  function openThemeDrawer() {
    var d = themeDrawer();
    if (d && typeof d.open === 'function') { d.open(); return true; }
    var toggle = document.querySelector('#cart-icon-bubble, [data-cart-drawer-toggle], .js-drawer-open-cart, [data-action="open-drawer"][data-drawer-id*="cart" i]');
    if (toggle) { toggle.click(); return true; }
    if (d) {
      d.classList.add('active', 'is-open', 'open');
      document.dispatchEvent(new CustomEvent('cart:open'));
      return true;
    }
    return false;
  }
 
  Array.prototype.forEach.call(root.querySelectorAll('[data-hdr-cart]'), function (link) {
    link.addEventListener('click', function (e) {
      if (cartAction === 'page') return;                  // native cart page
      if (cartAction === 'theme_drawer') {
        if (openThemeDrawer()) e.preventDefault();
        return;                                            // else fall through to the page
      }
      if (!cartEl) return;
      e.preventDefault();
      if (drawer && drawer.classList.contains('is-open')) closeDrawer();
      openCart();
    });
  });
 
  /* =========================================================
     8. Escape closes whatever is open
  ========================================================= */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (cartEl && cartEl.classList.contains('is-open')) return closeCart();
    if (drawer && drawer.classList.contains('is-open')) return closeDrawer();
    if (openKey) closeMega(true);
  });
 
  /* =========================================================
     9. Warm the menu images once idle
  ========================================================= */
  function warmImages() {
    if (!mega) return;
    Array.prototype.forEach.call(mega.querySelectorAll('img'), function (img) {
      var pre = new Image();
      if (img.srcset) pre.srcset = img.srcset;
      if (img.sizes) pre.sizes = img.sizes;
      pre.src = img.currentSrc || img.src;
    });
  }
  var warm = function () {
    if ('requestIdleCallback' in window) window.requestIdleCallback(warmImages, { timeout: 3000 });
    else window.setTimeout(warmImages, 2000);
  };
  if (document.readyState === 'complete') warm();
  else window.addEventListener('load', warm, { once: true });
 
  /* =========================================================
     10. Theme editor
  ========================================================= */
  document.addEventListener('shopify:block:select', function (e) {
    var block = e.target.closest('[data-hdr-panel]');
    if (block) openMega(block.dataset.hdrPanel);
  });
  document.addEventListener('shopify:block:deselect', function () { closeMega(true); });
 
  // first paint of the drawer contents
  if (cartEl) refreshCart(true);
})();